import axios, { AxiosError } from 'axios';

import TokenResponse from '../../App/Auth/TokenResponse';
import { Logout, RefreshToken } from '../Store/auth/actions';
import store from '../Store/Store';
import authHeaderInterceptor from './authHeaderInterceptor';
import client from './client';

let refreshing: Promise<any> | undefined;

export default function refreshTokenInterceptor(error: AxiosError) {
  if (
    !error.response ||
    error.response.status !== 401 ||
    error.config.headers.Authorization === undefined
  ) {
    throw error;
  }

  return new Promise((resolve, reject) => {
    const retryRequest = () => resolve(client().request(error.config));

    if (refreshing) {
      return refreshing.then(retryRequest);
    }

    refreshing = _client()
      .post<TokenResponse>('auth/refresh')
      .then(response => {
        refreshToken(response.data.access_token);
        retryRequest();
        return response;
      })
      .catch((e: AxiosError) => {
        unauthenticate();
        reject();
      })
      .finally(() => {
        refreshing = undefined;
      });
  });
}

/**
 * Get the HTTP client specific to refreshing the token.
 */
function _client() {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL || '',
  });

  instance.interceptors.request.use(authHeaderInterceptor);

  return instance;
}

function unauthenticate() {
  store.dispatch(new Logout());
}

function refreshToken(token: string) {
  store.dispatch(new RefreshToken(token));
}
